<script setup>
  import { computed, ref, watch } from "vue";
  import {
    getUserInfo,
  } from "@/lib/api";
  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
  });
  const userInfo = ref({});
  const emits = defineEmits(["update:show"]);

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  // Watch for modal show and fetch user info
  watch(() => props.show, (newVal) => {
    if (newVal) {
      userInfo.value = getUserInfo() || {};
    }
  });

  const isStudent = computed(() => userInfo.value.role === "stu");
  const roleLabel = computed(() => {

    console.log("userInfo.value:", userInfo.value);
    
    if (userInfo.value.role === "stu") return "학생";
    if (userInfo.value.role === "tea") return "교사";

    

    return "사용자";
  });

  const closeModal = () => {
    emits("update:show", false);
  };
</script>

<template>
  <ui-modal v-model:show="localShow" title="나의 정보" size="xs">
    <template #body>
      <div class="text-center">
        <h5 class="text-lg">{{ userInfo.name || "사용자" }} 님({{ roleLabel }})</h5>
        <p class="mt-1 text-gray-500">{{ userInfo.email || "-" }}</p>
      </div>
      <ui-table container-class="mt-4" variant="bordered">
        <colgroup>
          <col style="width: 120px" />
          <col style="width: auto" />
        </colgroup>
        <tbody>
          <tr>
            <th>학교</th>
            <td>{{ userInfo.schoolName || "-" }}</td>
          </tr>
          <tr v-if="isStudent">
            <th>학년-반</th>
            <td>{{ userInfo.grade && userInfo.classroom ? `${userInfo.grade}학년 ${userInfo.classroom}반` : "-" }}</td>
          </tr>
          <tr v-else>
            <th>학년-반</th>
            <td>{{ userInfo.grade && userInfo.classroom ? `${userInfo.grade}학년 ${userInfo.classroom}반` : "-" }}</td>
          </tr>
        </tbody>
      </ui-table>
      <helper-text class="mt-2"
        >최근 진단검사 접수 정보가 출력됩니다.</helper-text
      >
    </template>
    <template #footer>
      <div class="btn-area justify-end">
        <ui-button variant="outlined" color="gray" @click="closeModal"
          >닫기
        </ui-button>
      </div>
    </template>
  </ui-modal>
</template>
